import React, { useState, useEffect } from 'react';
import { FaShoppingBasket } from 'react-icons/fa';
import { BsHourglassSplit } from 'react-icons/bs';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { MdCancel } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { getUsersOrdersCounts, getOrderMonthlyCount } from '../../Redux/features/order/orderSlice';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const InfoPage = () => {
	const dispatch = useDispatch();
	const { ordersCount, isLoading } = useSelector((state) => state.order);
	const { monthlyOrderCounts } = useSelector((state) => state.order);
	const [BarChartData, setBarChartData] = useState([]);
	const currentDate = new Date();
	const endDate = currentDate.toISOString();

	// Set the startDate to the same day from the previous month
	const startDate = new Date(currentDate);
	startDate.setMonth(currentDate.getMonth() - 1); // Move back one month

	const formattedStartDate = startDate.toISOString();

	// Initial fetch only if there is no data in the redux store
	useEffect(() => {
		dispatch(getUsersOrdersCounts());
	}, [dispatch]);

	const cardData = [
		{
			id: 1,
			icon: <FaShoppingBasket className='text-red-400 text-4xl mb-2' />,
			backgroundColor: '#FFEBEE',
			title: 'Total Orders',
			value: ordersCount?.totalOrders ?? 0,
		},
		{
			id: 2,
			icon: <BsHourglassSplit className='text-blue-500 text-4xl' />,
			backgroundColor: '#E3F2FD',
			title: ' Pending Orders',
			value: ordersCount?.totalPendingOrders ?? 0,
		},
		{
			id: 3,
			icon: <AiOutlineCheckCircle className='text-orange-500 text-4xl' />,
			backgroundColor: '#FFF3E0',
			title: ' Completed Orders',
			value: ordersCount?.totalCompletedOrder ?? 0,
		},
		{
			id: 4,
			icon: <MdCancel className='text-purple-500 text-4xl' />,
			backgroundColor: '#EDE7F6',
			title: ' Cancelled Orders',
			value: ordersCount?.totalCancelledOrders ?? 0,
		},
	];

	useEffect(() => {
		if (!monthlyOrderCounts || (monthlyOrderCounts.length === 0 && !isLoading)) {
			const date = {
				startDate: formattedStartDate,
				endDate: endDate,
			};

			dispatch(getOrderMonthlyCount(date)).then((response) => {
				if (response.payload.success === true) {
					setBarChartData(response.payload.monthlyOrderCounts);
				}
			});
		} else {
			// If data already exists in the Redux store, use it
			setBarChartData(monthlyOrderCounts);
		}
	}, [dispatch, formattedStartDate, endDate, monthlyOrderCounts, isLoading]);

	const dynamicChartWidth = BarChartData.length * 150;

	return (
		<>
			{/* Cards showing order summary */}
			<div className='flex flex-wrap justify-center items-center md:gap-10 gap-5 py-20'>
				{cardData.map((card) => (
					<div
						key={card.id}
						className='flex flex-col justify-center items-center w-[250px] py-5 rounded-md shadow-xl'
						style={{ backgroundColor: card.backgroundColor }}>
						{card.icon}
						<p className='text-lg font-semibold whitespace-nowrap overflow-hidden text-ellipsis'>
							{card.title}
						</p>
						<p className='text-lg opacity-85 whitespace-nowrap overflow-hidden text-ellipsis'>
							{card.value}
						</p>
					</div>
				))}
			</div>

			<div className='flex justify-center items-center p-2 '>
				<div className=' max-lg:w-[700px]  max-sm:w-[380px] max-[400px]:w-[300px] max-[300px]:w-[250px] w-[80%] flex justify-center'>
					<div className=' overflow-x-auto custom-scrollbar'>
						{/* Conditionally render BarChart */}
						{BarChartData.length === 0 ? (
							<div></div>
						) : (
							<BarChart
								width={dynamicChartWidth || 500}
								height={420}
								margin={5}
								data={BarChartData}>
								<CartesianGrid strokeDasharray='3 3' />
								<XAxis dataKey='date' />
								<YAxis />
								<Tooltip />
								<Bar dataKey='totalOrders' fill='#FF6565' name='Order' />
								<Bar dataKey='pendingOrders' fill='#FFC107' name='Pending' />
								<Bar dataKey='completedOrders' fill='#4CAF50' name='Completed' />
								<Bar dataKey='cancelledOrders' fill='#F44336' name='Cancelled' />
							</BarChart>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default InfoPage;
